/**
 * @packageDocumentation
 * @module api.functional.admin.users.settings
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponsenull } from "../../../../structures/ServiceResponsenull";
import type { ServiceResponsePartialRecordUserNotificationType__type } from "../../../../structures/ServiceResponsePartialRecordUserNotificationType__type";
import type { ServiceResponseUserSettingsResponseDto } from "../../../../structures/ServiceResponseUserSettingsResponseDto";
import type { UpdateSettingsDto } from "../../../../structures/UpdateSettingsDto";

export * as timezone from "./timezone/index";

/**
 * @controller UserController.getSettings
 * @path GET /admin/users/settings
 * @accessor api.functional.admin.users.settings.getSettings
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getSettings(
  connection: IConnection,
): Promise<getSettings.Output> {
  return PlainFetcher.fetch(connection, {
    ...getSettings.METADATA,
    template: getSettings.METADATA.path,
    path: getSettings.path(),
  });
}
export namespace getSettings {
  export type Output = ServiceResponseUserSettingsResponseDto;

  export const METADATA = {
    method: "GET",
    path: "/admin/users/settings",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/admin/users/settings";
}

/**
 * @controller UserController.updateSettings
 * @path PATCH /admin/users/settings
 * @accessor api.functional.admin.users.settings.updateSettings
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateSettings(
  connection: IConnection,
  body: updateSettings.Body,
): Promise<updateSettings.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateSettings.METADATA,
      template: updateSettings.METADATA.path,
      path: updateSettings.path(),
    },
    body,
  );
}
export namespace updateSettings {
  export type Body = UpdateSettingsDto;
  export type Output =
    | ServiceResponsePartialRecordUserNotificationType__type
    | ServiceResponsenull;

  export const METADATA = {
    method: "PATCH",
    path: "/admin/users/settings",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/admin/users/settings";
}
